import { render } from "./SecurityTemplate.vue?vue&type=template&id=3683d369"
import script from "./SecurityTemplate.vue?vue&type=script&lang=js"
export * from "./SecurityTemplate.vue?vue&type=script&lang=js"

import "./SecurityTemplate.vue?vue&type=style&index=0&id=3683d369&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__